import classNames from 'classnames';
import { ReactNode, useEffect, useRef } from 'react';

import styles from './AccordionFilter.module.scss';

interface AccordionFilterProps {
  isOpen: boolean;
  children: ReactNode;
  className?: string;
  title: {
    className?: string;
    content: ReactNode;
  };
  handlerOpen: () => void;
}

export const AccordionFilter = ({ isOpen, children, className, title, handlerOpen }: AccordionFilterProps) => {
  const AccordionContentRef = useRef<HTMLDivElement>();
  useEffect(() => {
    const timer = setTimeout(() => {
      AccordionContentRef.current.style.overflow = isOpen ? 'visible' : 'hidden';
    }, 500);
    return () => clearTimeout(timer);
  }, [isOpen]);

  return (
    <div className={classNames(styles.Wrapper, className)}>
      <div className={classNames(styles.Title, title.className)} onClick={handlerOpen}>
        {title.content}
      </div>
      <div ref={AccordionContentRef} className={classNames(styles.Content, { [styles.Open]: isOpen })}>
        {children}
      </div>
    </div>
  );
};
